import React, { Component, Fragment } from 'react';
import { Redirect } from 'react-router-dom';

import { Modal, ModalHeading } from '@sainsburys-tech/luna-modal';

const withErrorHandler = (WrappedComponent, axios) => {
    return class extends Component {
        isMountedRef = false;

        state = {
            error: null,
            toHome: false
        };

        safeSetState = stateUpdate => {
            if (this.isMountedRef) this.setState(stateUpdate);
        };

        componentDidMount() {
            this.isMountedRef = true;

            this.reqInterceptor = axios.interceptors.request.use(req => {
                this.safeSetState({ error: null });
                return req;
            });

            this.resInterceptor = axios.interceptors.response.use(res => res, error => {
                this.safeSetState({ error: error });
                return Promise.reject(error);
            });
        }

        componentWillUnmount() {
            this.isMountedRef = false;

            axios.interceptors.request.eject(this.reqInterceptor);
            axios.interceptors.response.eject(this.resInterceptor);
        }

        errorConfirmedHandler = () => {
            this.safeSetState({ error: null, toHome: true });
        };

        render() {

            if (this.state.toHome === true) {
                return <Redirect to="/" />;
            }

            return (
                <Fragment>
                    <Modal
                        small
                        handleClose={this.errorConfirmedHandler}
                        open={this.state.error !== null} >
                        <ModalHeading element="h3">Oops, we've hit an error</ModalHeading>
                        <p>{this.state.error ? this.state.error.message : ''}</p>
                    </Modal>
                    <WrappedComponent {...this.props} />
                </Fragment>
            );
        }
    };
};

export default withErrorHandler;
